// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__aQd_p","errors":"Errors_errors__3qzM-"};